// components/Molecules/CountrySelector/CountrySelector.js
import FormField from '../FormField/FormField';
import COUNTRIES from './CountrySelector.data';

const CountrySelector = ({ value, onChange }) => (
  <FormField
    as="select"
    name="country"
    label="Country"
    value={value}
    onChange={onChange}
    options={COUNTRIES}
    placeholder="Select a country"
  />
);

export default CountrySelector;